import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less'; //1920
// import styles from './rem.less'; //2560
import Link from '@src/components/link';
import CookieSettingModalStore from './store';
import cookieLocalesData from '@src/business-components/cookie-tips/cookie.json';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const lang = getLanguageByPath();
const cookieInfo = cookieLocalesData[lang]?.cookieInfo;
/**
 * CookieSettingModal
 * @param store {CookieSettingModalStore}
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const CookieSettingModal = ({ store, onClose }) => {
  store.use();
  store.onClose = onClose;
  const renderNecessaryCookiesList = () => {
    if (store.necessaryCookiesList.length > 0) {
      return store.necessaryCookiesList.map((item, key) => {
        return (
          <div className={styles.cookieItem} key={key}>
            <div className={styles.infoItem}>
              {cookieInfo.label_name}: <span>{item.name}</span>
            </div>
            <div className={styles.infoItem}>
              {cookieInfo.label_provider}: <span>{item.provider}</span>
            </div>
            <div className={styles.infoItem}>
              {cookieInfo.label_duration}: <span> {item.duration}</span>
            </div>
            <div className={styles.infoItem}>
              {cookieInfo.label_description}: <span>{item.description}</span>
            </div>
          </div>
        );
      });
    }
  };

  const renderAnalyseCookiesList = () => {
    if (store.necessaryCookiesList.length > 0) {
      return store.analyseCookiesList.map((item, key) => {
        return (
          <div className={styles.cookieItem} key={key}>
            <div className={styles.infoItem}>
              {cookieInfo.label_name}: <span>{item.name}</span>
            </div>
            <div className={styles.infoItem}>
              {cookieInfo.label_provider}: <span>{item.provider}</span>
            </div>
            <div className={styles.infoItem}>
              {cookieInfo.label_duration}: <span> {item.duration}</span>
            </div>
            <div className={styles.infoItem}>
              {cookieInfo.label_description}: <span>{item.description}</span>
            </div>
          </div>
        );
      });
    }
  };

  /**
   * 渲染主内容
   * @returns {JSX.Element}
   */
  const renderContainer = () => {
    if (store.isPreferenceSetting /**是否为首页*/) {
      return (
        <div className={styles.preferenceSettingContainer}>
          <div className={styles.cookieDesc}>{cookieInfo.settings_description}</div>
          <div className={styles.necessaryCookiesDesc}>
            <div className={styles.contentPart}>
              <div className={styles.contentPartTop}>
                <div className={styles.contentPartTopTitle}>{cookieInfo.necessary_cookies}</div>
                <Link className={styles.viewDetails} onClick={() => store.redirectToPage(1)}>
                  {cookieInfo.view_details}
                </Link>
              </div>
              <div className={styles.contentPartBottom}>{cookieInfo.necessary_cookies_description}</div>
            </div>
            <div className={styles.operateBtn}>
              <div
                className={cx(styles.switchBtn, styles.lockedStatusSwitch)}
              // onClick={() => store.onChangeAcceptCookieStatus('necessary')}
              />
            </div>
          </div>
          <div className={styles.AnalyticsCookiesDesc}>
            <div className={styles.contentPart}>
              <div className={styles.contentPartTop}>
                <div className={styles.contentPartTopTitle}>{cookieInfo.analytics_cookies}</div>
                <Link className={styles.viewDetails} onClick={() => store.redirectToPage(2)}>
                  {cookieInfo.view_details}
                </Link>
              </div>
              <div className={styles.contentPartBottom}>{cookieInfo.analytics_cookies_description}</div>
            </div>
            <div className={styles.operateBtn}>
              <Link
                className={cx(styles.switchBtn, store.acceptCookies.analytics && styles.openStatusSwitch)}
                onClick={() => store.onChangeAcceptCookieStatus('analytics')}
              />
            </div>
          </div>
        </div>
      );
    } else if (store.isNecessaryCookies) {
      return <div className={styles.necessaryCookiesContainer}>{renderNecessaryCookiesList()}</div>;
    } else if (store.isAnalyticsCookies) {
      return <div className={styles.analyticsCookiesContainer}>{renderAnalyseCookiesList()}</div>;
    } else {
      return null;
    }
  };
  const renderHeader = () => {
    if (store.isPreferenceSetting /**是否为首页*/) {
      return <div className={cx(styles.headerContainer, styles.preferenceSettingHeader)}> {cookieInfo.perference_settings}</div>;
    } else if (store.isNecessaryCookies) {
      return (
        <div className={cx(styles.headerContainer, styles.necessaryCookiesHeader)}>
          <Link className={styles.backBtn} onClick={store.backToIndex} />
          {cookieInfo.necessary_cookies}
        </div>
      );
    } else if (store.isAnalyticsCookies) {
      return (
        <div className={cx(styles.headerContainer, styles.analyticsCookiesHeader)}>
          <Link className={styles.backBtn} onClick={store.backToIndex} />
          {cookieInfo.analytics_cookies}
        </div>
      );
    } else {
      return null;
    }
  };
  /**
   * 渲染按钮区域
   * @returns {JSX.Element}
   */
  const renderBtnGroup = () => {
    return (
      <div className={styles.btnGroupContainer}>
        <div className={styles.btnGroup}>
          <Link className={cx(styles.smallSizeBtn)} onClick={store.onConfirmCookieOptionsClick}>
            {cookieInfo.confirm_btn}
          </Link>
          <Link className={cx(styles.smallSizeBtn)} onClick={store.acceptAllCookie}>
            {cookieInfo.allow_all_btn}
          </Link>
        </div>
      </div>
    );
  };
  if (!store.isShow) {
    return null;
  }
  return (
    <div className={cx(styles.root)}>
      <div className={styles.mask} />
      <div className={styles.modalContainer}>
        <Link className={styles.closeBtn} onClick={store.onClose} />
        {renderHeader()}
        <div className={styles.container}>{renderContainer()}</div>
        {renderBtnGroup()}
      </div>
    </div>
  );
};

export default wrapStore(CookieSettingModal, CookieSettingModalStore);
